import { useTranslations } from 'next-intl';
import { CustomImage as Image } from 'components/shared';
import { BentoHeading, BentoPara } from './StyleConstants';
import styles from './TempratureCard.module.css';

const SensorCircles = (
  <svg
    width="280"
    height="280"
    viewBox="0 0 280 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="140.008" cy="139.997" r="32.4412" stroke="#05FF00" />
    <circle cx="139.999" cy="139.999" r="40.6765" stroke="#05FF00" />
    <circle cx="139.99" cy="140.001" r="48.9118" stroke="#05FF00" />
    <circle cx="140.003" cy="140.003" r="57.147" stroke="#05FF00" />
    <circle cx="139.994" cy="140.004" r="65.3823" stroke="#05FF00" />
    <circle cx="140.006" cy="139.996" r="73.6177" stroke="#05FF00" />
    <circle
      cx="139.997"
      cy="139.997"
      r="81.853"
      stroke="#05FF00"
      strokeOpacity="0.9"
      style={{ animationDelay: `0.1s` } as React.CSSProperties}
    />
    <circle
      cx="140.01"
      cy="139.999"
      r="90.0882"
      stroke="#05FF00"
      strokeOpacity="0.8"
      style={{ animationDelay: `0.3s` } as React.CSSProperties}
    />
    <circle
      cx="140.001"
      cy="140.001"
      r="98.3235"
      stroke="#05FF00"
      strokeOpacity="0.7"
      style={{ animationDelay: `0.5s` } as React.CSSProperties}
    />
    <circle
      cx="139.992"
      cy="140.003"
      r="106.559"
      stroke="#05FF00"
      strokeOpacity="0.6"
      style={{ animationDelay: `0.7s` } as React.CSSProperties}
    />
    <circle
      cx="140.005"
      cy="140.005"
      r="114.794"
      stroke="#05FF00"
      strokeOpacity="0.5"
      style={{ animationDelay: `0.9s` } as React.CSSProperties}
    />
    <circle
      cx="139.996"
      cy="139.996"
      r="123.029"
      stroke="#05FF00"
      strokeOpacity="0.4"
      style={{ animationDelay: `1.1s` } as React.CSSProperties}
    />
    <circle
      cx="140.009"
      cy="139.998"
      r="131.265"
      stroke="#05FF00"
      strokeOpacity="0.3"
      style={{ animationDelay: `1.3s` } as React.CSSProperties}
    />
    <circle
      cx="140"
      cy="140"
      r="139.5"
      stroke="#05FF00"
      strokeOpacity="0.1"
      style={{ animationDelay: `1.5s` } as React.CSSProperties}
    />
  </svg>
);

export const TempratureCard = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const tHome = useTranslations('home');
  return (
    <div className={`${styles.root} container${className ? ` ${className}` : ''}`}>
      <Image
        src="web_v2/illustrations/ring-air-front.png"
        fill
        sizes="(min-width: 992px) 63vw, 125vw"
        alt={tHome('home.bentoCards.temperature.alt')}
      />
      <BentoHeading>{t('ring.bentoSection.tempCard.head')}</BentoHeading>
      <BentoPara>
        <b>{t('ring.SKIN_TEMPERATURE')}</b>{' '}
        {t('ring.bentoSection.tempCard.desc')}
      </BentoPara>

      {SensorCircles}
    </div>
  );
};
